import React from 'react';
import ReactDOM from 'react-dom/client';
import "./i18n/config.ts";
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LoaderProvider } from './contexts/LoaderContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <LoaderProvider>
      <App />
    </LoaderProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
